// Figma's pointer (Design System, Tooltips/Default 582:4390) is an equilateral
// triangle rounded at `_radius/rounded-sm`, and the content covers all of it
// but the 8px nearest the tip. What shows is a 60° point, its base on the
// content's edge and its tip rounded.
const HEIGHT = 8;
const TIP_RADIUS = 2;
const WIDTH = (2 * HEIGHT) / Math.sqrt(3);

// The tip's arc meets each side `TIP_RADIUS / tan 30°` from the sharp tip;
// the sides run at 60°, so that's this far across and up from it
const TANGENT = TIP_RADIUS * Math.sqrt(3);
const TANGENT_X = TANGENT / 2;
const TANGENT_Y = HEIGHT - (TANGENT * Math.sqrt(3)) / 2;

/**
 * The tooltip arrow on both platforms, drawn as in Figma. `path` points down
 * in a `width` × `height` box with its base on the content's edge; the sharp
 * tip would be at `height`, and the rounding ends it `TIP_RADIUS` short of
 * that. Both platforms point it at the trigger (Radix on web, `aimTooltipArrow`
 * on native, which keeps its base `cornerInset` clear of the content's
 * corners, Figma's 8px radius). Until native has measured, start and end
 * alignment put the tip `tipInset` from the content's edge. Raw values by
 * decision (audit Tooltip #6): one place, no design tokens.
 */
export const TOOLTIP_ARROW = {
  width: WIDTH,
  height: HEIGHT,
  path:
    `M0 0H${WIDTH}` +
    `L${WIDTH / 2 + TANGENT_X} ${TANGENT_Y}` +
    `A${TIP_RADIUS} ${TIP_RADIUS} 0 0 1 ${WIDTH / 2 - TANGENT_X} ${TANGENT_Y}Z`,
  tipInset: 24,
  cornerInset: 8,
} as const;
